import type { RouteRecordRaw } from "vue-router";

import { generateRouteNavs } from "@/utils/navs";

import wenbenshengma from "@/assets/home/wenbenshengma.png";
import wangzhishengma from "@/assets/home/wangzhishengma.png";
import wenjianshengma from "@/assets/home/wendangshengma.png";
import tupianshengma from "@/assets/home/tupianshengma.png";
import yinpinshengma from "@/assets/home/yinpinshengma.png";
import shipinshengma from "@/assets/home/shipinshengma.png";
import dianzihuace from "@/assets/home/dianzihuace.png";

const homeChildren: RouteRecordRaw[] = [
  {
    path: "/home/text",
    name: "Text",
    meta: {
      name: "文本",
      format: true,
      icon: wenbenshengma,
    },
    component: () => import("@/views/home/views/text/index.vue"),
  },
  {
    path: "/home/network",
    name: "network",
    meta: {
      name: "网址",
      format: true,
      icon: wangzhishengma,
    },
    component: () => import("@/views/home/views/network/index.vue"),
  },
  {
    path: "/home/file",
    name: "file",
    meta: {
      name: "文件",
      format: true,
      icon: wenjianshengma,
    },
    component: () => import("@/views/home/views/file/index.vue"),
  },
  {
    path: "/home/image",
    name: "image",
    meta: {
      name: "图片",
      format: true,
      icon: tupianshengma,
    },
    component: () => import("@/views/home/views/image/index.vue"),
  },
  {
    path: "/home/audio",
    name: "audio",
    meta: {
      name: "音频",
      format: true,
      icon: yinpinshengma,
    },
    component: () => import("@/views/home/views/audio/index.vue"),
  },
  {
    path: "/home/video",
    name: "video",
    meta: {
      name: "视频",
      format: true,
      icon: shipinshengma,
    },
    component: () => import("@/views/home/views/video/index.vue"),
  },
  {
    path: "/home/book",
    name: "book",
    meta: {
      name: "电子画册",
      format: true,
      icon: dianzihuace,
    },
    component: () => import("@/views/home/views/book/index.vue"),
  },
];

export const publicNavs = generateRouteNavs(homeChildren);

export const homeRoute: RouteRecordRaw[] = [
  {
    path: "/home",
    redirect: homeChildren[0].path,
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      name: "首页",
    },
    component: () => import("@/views/home/index.vue"),
    children: homeChildren,
  },
  {
    path: "/vip",
    name: "VIP",
    meta: {
      name: "VIP会员",
      hot: true,
    },
    component: () => import("@/views/vip/index.vue"),
  },
  {
    path: "/active/:key",
    name: "active",
    component: () => import("@/views/active/index.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "notFound",
    component: () => import("@/views/NotFound/index.vue"),
  },
];
